<template>
  <a-card title="材料分类" size="small" :loading="loading" style="overflow:auto;">
    <a-input
      v-model:value="keyword"
      allow-clear
      style="margin-bottom: 8px"
      placeholder="请输入材料分类关键字"
    >
      <template #prefix>
        <ant-icon type="SearchOutlined"></ant-icon>
      </template>
    </a-input>
    <a-tree
      :auto-expand-parent="autoExpandParent"
      :expandedKeys="expandedKeys"
      v-model:selectedKeys="selectedKeys"
      :tree-data="treeRecords"
      :fieldNames="{ children: 'children', title: 'name', key: 'id' }"
      @expand="onExpand"
      @select="onSelect"
      :style="{height:height+'px','overflow':'auto'}"
    >
      <template #title="{ name, id }">
        <span :style="id === null ? { fontWeight: 'bold', fontSize: '15px' } : {}">
          <span v-if="name.indexOf(keyword) > -1">
            <span>{{ name.substr(0, name.indexOf(keyword)) }}</span>
            <span style="color: #f50">{{ keyword }}</span>
            <span>{{ name.substr(name.indexOf(keyword) + keyword.length) }}</span>
          </span>
          <span v-else>{{ name }}</span>
        </span>
      </template>
    </a-tree>
  </a-card>
</template>

<script lang="ts">
import { defineComponent, onMounted, reactive, toRefs, watch,computed,Ref } from "vue";
import { CategoryService } from "@/views/material/category/category.service";
import { CategorySimpleRecord } from "@/views/material/category/category.interface";
import { notifyEmitter } from "@/utils/emitter";

const getParentKey = (key: any, tree: any): any => {
  let parentKey;
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i];
    if (node.children) {
      if (node.children.some((item) => item.id === key)) {
        parentKey = node.id;
      } else if (getParentKey(key, node.children)) {
        parentKey = getParentKey(key, node.children);
      }
    }
  }
  return parentKey;
};

interface IState {
  keyword: string;
  autoExpandParent: boolean;
  records: CategorySimpleRecord[];
  treeRecords: CategorySimpleRecord[];
  expandedKeys: any[];
  selectedKeys: any[];
  height:Ref<Number>;
}

export default defineComponent({
  name: "CategoryTree",
  props: {
    value: {
      type: String,
      default: "",
    },
    treeHeight:{
      type:Number,
      default:700
    }
  },
  emits: ["update:value","update:treeHeight"],
  setup(props, { emit }) {
    const state = reactive<IState>({
      keyword: "",
      autoExpandParent: false,
      records: [],
      treeRecords: [],
      expandedKeys: [],
      selectedKeys: [],
      height:computed(()=>{
        return props.treeHeight-122-30;
      })
    });

    const { loading, run } = CategoryService.useSimpleListWithAllApi();

    const onExpand = (keys: string[]) => {
      state.expandedKeys = keys;
      state.autoExpandParent = false;
    };

    const onSelect = (ids: any[]) => {
      if (ids && ids.length) {
        emit("update:value", ids[0]);
      }
    };

    notifyEmitter.on("refreshTree", async() => {
      await search();
    });

    const search = async () => {
      const res = await run();
      if (res.respCode === "0000") {
        state.records = res.data?.records || [];
        state.treeRecords = res.data?.treeRecords || [];
        if (state.treeRecords.length) {
          const allNode = state.records.find(item => item.id === null);
          const defaultId = allNode ? allNode.id : state.treeRecords[0].id;
          state.selectedKeys = [defaultId];
          emit("update:value", defaultId);
        }
      }
    };

    onMounted(async () => {
      await search();
    });

    watch(
      () => state.keyword,
      (keyword) => {
        if (!keyword) {
          state.expandedKeys = [];
          return;
        }
        const expanded = state.records
          .map((item) => {
            if (item.name.includes(keyword)) {
              return getParentKey(item.id, state.treeRecords);
            }
            return null;
          })
          .filter((item, i, self) => item && self.indexOf(item) === i);
        state.expandedKeys = expanded as string[];
        state.keyword = keyword;
        state.autoExpandParent = true;
      }
    );

    return {
      ...toRefs(state),
      loading,
      onExpand,
      onSelect,
    };
  },
});
</script>
